import { ActionTypes } from '../../constants/ActionTypes';

const INIT_STATE = {
  // v1 <==
  loading: true,
  disableSendFileInChat: true,
  uploadModel: null,
  imgUrls: [],
  // v2 <==
  userRooms: [],
  selectedRoom: null,
  searchRooms: [],
  userInfo: null,
  conversations: [],
  newMsgCallback: null,
  unDeliveredIs: new Array<number>(),
  unReadIds: new Array<number>(),
  userRoomsWithNewMessage: [],
  userRoomsDetailWithNewMessage: [],
  signalRIsDisconnected: false,
  disableSendFileInChatFinal: false,
  sendRequestForGetNewMessage: false,
};

export default (state = INIT_STATE, action: any) => {
  switch (action.type) {
    // v1 <==
    case ActionTypes.GET_DISABLE_SEND_FILE_IN_CHAT: {
      return {
        ...state,
        disableSendFileInChatFinal: true,
      };
    }

    case ActionTypes.FETCH_DISABLE_SEND_FILE_IN_CHAT_SUCCESS: {
      return {
        ...state,
        disableSendFileInChat: action.payload,
      };
    }

    case ActionTypes.CHAT_FILE_UPLOAD: {
      return {
        ...state,
        uploadModel: action.payload,
      };
    }

    case ActionTypes.CHAT_FILE_UPLOAD_SUCCESS: {
      return {
        ...state,
      };
    }

    case ActionTypes.ADD_CHAT_IMG_URL: {
      const item = action.payload as never;
      const clone = [...state.imgUrls, item];
      return {
        ...state,
        imgUrls: clone,
      };
    }

    case ActionTypes.CLEAR_CHAT_IMG_URL: {
      return {
        ...state,
        imgUrls: [],
      };
    }

    // v2 <==
    case ActionTypes.GET_USER_ROOMS: {
      return {
        ...state,
        userRooms: [],
      };
    }

    case ActionTypes.FETCH_USER_ROOMS_SUCCESS: {
      return {
        ...state,
        userRooms: action.payload,
      };
    }

    case ActionTypes.SELECT_ROOM: {
      const room = action.payload;

      const userRoomsDetailWithNewMessageClone = [
        ...state.userRoomsDetailWithNewMessage,
      ];
      const userRoomsWithNewMessageClone = [...state.userRoomsWithNewMessage];
      let targetUserRoomsDetailWithNewMessage;
      let targetUserRoomsWithNewMessage;
      if (room && room.Id) {
        targetUserRoomsDetailWithNewMessage =
          userRoomsDetailWithNewMessageClone.filter(
            (item: any) => item.Id !== room.Id,
          );
        targetUserRoomsWithNewMessage = userRoomsWithNewMessageClone.filter(
          (item: any) => item !== room.Id,
        );
        // userRoomsWithNewMessage
      } else {
        targetUserRoomsDetailWithNewMessage =
          userRoomsDetailWithNewMessageClone;
        targetUserRoomsWithNewMessage = userRoomsWithNewMessageClone;
      }

      return {
        ...state,
        selectedRoom: room,
        userRoomsDetailWithNewMessage: targetUserRoomsDetailWithNewMessage,
        userRoomsWithNewMessage: targetUserRoomsWithNewMessage,
      };
    }

    // case ActionTypes.GET_NEW_ROOM_MESSAGES: {
    //     return {
    //         ...state,
    //         conversations: [],
    //     };
    // }

    case ActionTypes.FETCH_NEW_ROOM_MESSAGES_SUCCESS: {
      const { roomId } = action.payload;

      const userRooms = [...state.userRooms];

      const oldList = state.conversations;
      const newList = action.payload.list;

      const targetList = [...oldList, ...newList];

      const ids = [...targetList.map((msg: any) => msg.Id)];

      const minId = Math.min(...ids);
      const maxId = Math.max(...ids);

      userRooms.map((item: any) => {
        if (item.Id === roomId) {
          item.MinId = minId;
          item.MaxId = maxId;
        }
        return item;
      });

      let unReadIdsClone = [...state.unReadIds];

      newList.map((item: any) => {
        if (item.UnRead) {
          unReadIdsClone = [...unReadIdsClone, item.Id];
        }
      });

      const resArr = [] as any;

      targetList.forEach(function (item) {
        const i = resArr.findIndex((x: any) => x.Id == item.Id);
        if (i <= -1) {
          resArr.push({
            Id: item.Id,
            ContentType: item.ContentType,
            MessageText: item.MessageText,
            RoomId: item.RoomId,
            SendDateTime: item.SendDateTime,
            SendDateTimeStandard: item.SendDateTimeStandard,
            SenderEmployeeId: item.SenderEmployeeId,
            SenderName: item.SenderName,
            UnDelivered: item.UnDelivered,
            UnRead: item.UnRead,
          });
        }
      });

      const r = {
        ...state,
        userRooms: userRooms,
        conversations: resArr,
        unReadIds: new Array<number>(),
      };
      const s = new Set(unReadIdsClone);
      s.forEach((x) => r.unReadIds.push(x));
      return r;
    }

    case ActionTypes.GET_OLD_ROOM_MESSAGES: {
      return {
        ...state,
        conversations: [],
      };
    }

    case ActionTypes.CLEAR_CONVERSATIONS_MESSAGES: {
      return {
        ...state,
        conversations: [],
      };
    }

    case ActionTypes.FETCH_OLD_ROOM_MESSAGES_SUCCESS: {
      const { roomId, list } = action.payload;

      const userRooms = [...state.userRooms];
      const ids = [...list.map((msg: any) => msg.Id)];

      const minId = Math.min(...ids);
      const maxId = Math.max(...ids);

      userRooms.map((item: any) => {
        if (item.Id === roomId) {
          item.MinId = minId;
          item.MaxId = maxId;
        }
        return item;
      });

      let unReadIdsClone = [...state.unReadIds];

      list.map((item: any) => {
        if (item.UnRead) {
          unReadIdsClone = [...unReadIdsClone, item.Id];
        }
      });

      const r = {
        ...state,
        userRooms: userRooms,
        conversations: list.reverse(),
        unReadIds: new Array<number>(),
        signalRIsDisconnected: false,
      };
      const s = new Set(unReadIdsClone);
      s.forEach((x) => r.unReadIds.push(x));
      return r;
    }

    case ActionTypes.SEARCH_ROOMS: {
      return {
        ...state,
        searchRooms: [],
      };
    }

    case ActionTypes.SEARCH_ROOMS_SUCCESS: {
      return {
        ...state,
        searchRooms: action.payload,
      };
    }

    case ActionTypes.GET_USER_INFO: {
      return {
        ...state,
        userInfo: null,
      };
    }

    case ActionTypes.GET_USER_INFO_SUCCESS: {
      return {
        ...state,
        userInfo: action.payload,
      };
    }

    case ActionTypes.SEND_TEXT_MESSAGE_SUCCESS: {
      const newconversations = [...state.conversations, action.payload];

      return {
        ...state,
        conversations: newconversations,
      };
    }

    case ActionTypes.NOTIFY_NEW_MESSAGE: {
      // اگر پیام جدید برای
      // selectedRoom
      // نبود باید کاربری که این پیام از طرف اون هستش به
      // userRoomsWithNewMessage
      // اضافه شود

      if (!action.payload) return state;

      const { selectedRoom } = state as any;
      let target = new Array<number>();
      const roomId = action.payload.RoomId;

      if (selectedRoom) {
        if (selectedRoom.Id !== roomId) {
          target = [...state.userRoomsWithNewMessage, roomId];
        }
      } else {
        target = [...state.userRoomsWithNewMessage, roomId];
      }

      const r = {
        ...state,
        newMsgCallback: action.payload,
        userRoomsWithNewMessage: new Array<number>(),
      };
      const s = new Set(target);
      s.forEach((x) => r.userRoomsWithNewMessage.push(x));
      return r;
    }

    case ActionTypes.ADD_NEW_ROOM_SUCCESS: {
      const newUserRooms = [...state.userRooms, action.payload];

      return {
        ...state,
        userRooms: newUserRooms,
      };
    }

    case ActionTypes.CLEAR_UNREAD_IDS: {
      const unReadIdsClone = [...state.unReadIds];

      const newUnReadIds = unReadIdsClone.filter(
        (item) => !action.payload.includes(item),
      );

      return {
        ...state,
        unReadIds: newUnReadIds,
      };
    }

    case ActionTypes.GET_USER_ROOMS_WITH_NEW_MESSAGE: {
      return {
        ...state,
        sendRequestForGetNewMessage: true,
      };
    }

    case ActionTypes.GET_USER_ROOMS_WITH_NEW_MESSAGE_SUCCESS: {
      return {
        ...state,
        userRoomsWithNewMessage: action.payload,
      };
    }

    case ActionTypes.GET_USER_ROOMS_DETAIL_WITH_NEW_MESSAGE_SUCCESS: {
      const clone = [...state.userRoomsDetailWithNewMessage, action.payload];

      return {
        ...state,
        userRoomsDetailWithNewMessage: clone,
      };
    }

    case ActionTypes.IS_DISCONNECTED: {
      return {
        ...state,
        signalRIsDisconnected: true,
      };
    }

    default:
      return state;
  }
};
